import { jsx as _jsx } from "react/jsx-runtime";
import { BtnFactory, SIZE } from './BtnFactory';
export { SIZE };
export function CtaLink(props) {
    return _jsx(BtnFactory, { as: 'a', severity: 'cta', ...props });
}
//# sourceMappingURL=CtaLink.js.map